import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AdaCustomization, AdaCustomizationsService, ModalComponent } from 'core/index';
import { DocumentsService } from 'app/documents/documents.service';
import { environment } from 'environments/environment';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'lms-customization-visualizer-popup',
  templateUrl: './customization-visualizer-popup.component.html',
  styleUrls: ['./customization-visualizer-popup.component.scss']
})
export class CustomizationVisualizerPopupComponent implements OnInit {
  public selectedTurn: any;
  public selectedDocument: any;
  public selectedDocumentURL: String;
  public indexDocument: number;
  public showTest = false;
  public test: any;
  public customization: AdaCustomization;

  @ViewChild(ModalComponent, { static: false }) public modal: ModalComponent;

  constructor(
    public documentsService: DocumentsService,
    public route: ActivatedRoute,
    public AdaCustomizationsService: AdaCustomizationsService
  ) {}

  ngOnInit() {}

  popupOpen() {
    this.route.paramMap
      .pipe(switchMap((params: ParamMap) => this.AdaCustomizationsService.getCustomization(params.get('id'), true)))
      .subscribe((customization) => {
        this.customization = customization as AdaCustomization;
        this.modal.open();
        setTimeout(() => {
          const firstTurn = this.customization.content.length && this.customization.content[0].turn;
          this.selectTurn(firstTurn);
        }, 1);
      });
  }

  popupClose() {
    const iframe = document.getElementById('iframeDocument');
    if (iframe) {
      iframe['src'] = '';
    }
    this.modal.close();
  }

  selectTurn(turn) {
    this.showTest = false;
    this.indexDocument = 0;
    this.selectedTurn = this.customization.content.find((ele) => ele.turn === turn);
    if (this.selectedTurn && this.selectedTurn.documents.length) {
      this.selectDocument();
    }
  }
  getDocumentUrl(url) {
    const streamingTypes = ['.mp3', '.m4a', '.wav', '.mp4', '.mov', '.webm', '.MPG'];
    const host = streamingTypes.find((type) => url.includes(type))
      ? environment.STREAMING_HOST
      : environment.RESOURCES_HOST;
    if (!url.match(host)) {
      return host + url;
    }
    return url;
  }

  selectDocument() {
    this.selectedDocument = this.selectedTurn.documents[this.indexDocument];
    const url = this.getDocumentUrl(this.selectedDocument.url);
    setTimeout(() => {
      document.getElementById('iframeDocument')['src'] = this.documentsService.formatVideoEmbedUrl(url);
    }, 0);
  }

  prev() {
    if (this.indexDocument > 0) {
      this.indexDocument -= 1;
      this.selectDocument();
    }
  }
  next() {
    if (this.indexDocument < this.selectedTurn.documents.length - 1) {
      this.indexDocument += 1;
      this.selectDocument();
    }
  }

  toggleTest() {
    this.showTest = !this.showTest;
    this.test = [];
    this.selectedTurn.documents.forEach((doc) => {
      this.test = this.test.concat(doc.questions);
    });
    if (!this.showTest) {
      this.selectTurn(this.selectedTurn.turn);
    }
  }
}
